<script setup lang="ts">
import VFieldModel from "addeus-common-library/components/model/VFieldModel.vue";
import { EntityBase, Input } from "addeus-common-library/stores/firestore";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import Helmet from "../../assets/account/profile-personal-infos.svg";
import Megaphone from "../../assets/icons/communication-2.svg";
import RGPD from "../../../public/pdf/Politique_confidentialite-Speed2Max_Karting.pdf";
import { computed, ref } from "vue";
import * as yup from "yup";
import functions from "addeus-common-library/stores/function";
import VValidation from "addeus-common-library/components/base/form/VValidation.vue";
import VCheckbox from "addeus-common-library/components/base/form/VCheckbox.vue";
import Translate from "addeus-common-library/components/base/translation/Translate.vue";

// enum RequestType {
//     Seminar = "Seminar",
//     ShowCase = "Showcase",
//     Party = "party",
//     Event = "event",
//     Ticketing = "ticketing",
//     Other = "other",
// }

class FormContent extends EntityBase {
    @Input("text", { required: true })
    firstName: string = "";

    @Input("text", { required: true })
    lastName: string = "";

    @Input("phone", { required: true })
    phoneNumber: string = "";

    @Input("email", { required: true })
    email: string = "";

    // @Input("select", { required: false, options: RequestType })
    // request?: RequestType;

    @Input("textarea", { required: false })
    message: string = "";

    @Input("checkbox", { required: true })
    consent: boolean = false;

    public resetFrom(): void {
        this.firstName = "";
        this.lastName = "";
        this.phoneNumber = "";
        this.email = "";
        this.message = "";
        this.consent = false;
    }
}

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanXl = breakpoints.smallerOrEqual("xl");
const content = ref(new FormContent());
const schema = yup.object({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    phoneNumber: yup.string().required(),
    email: yup.string().required().email(),
    consent: yup.boolean().required().isTrue(),
});
const isSent = ref(false);

function validateContent() {
    const value = schema.isValidSync(content.value);
    return value;
}

const isValid = computed(validateContent);

async function sendEmail() {
    try {
        await functions.sendEmailContactEventYourV2(content.value);
        isSent.value = true;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
}
</script>

<template>
    <div class="is-flex is-flex-direction-column card has-background-light">
        <div v-if="!isSent" class="is-flex is-flex-direction-column">
            <div class="is-flex m-2">
                <img class="image is-48x48 p-1" :src="Helmet" alt="logo" />
                <p
                    class="is-size-5 has-text-black has-text-weight-bold my-auto ml-2 is-family-primary">
                    <Translate>.title.info</Translate>
                </p>
            </div>
            <VFlex :flex-direction="smallerThanXl ? 'column' : 'row'" class="my-2">
                <VFieldModel
                    v-model="content"
                    property="lastName"
                    class="is-flex-grow-1 mx-4"></VFieldModel>
                <VFieldModel
                    v-model="content"
                    property="firstName"
                    class="is-flex-grow-1 mx-4"></VFieldModel>
            </VFlex>
            <VFlex :flex-direction="smallerThanXl ? 'column' : 'row'" class="my-2">
                <VFieldModel
                    v-model="content"
                    property="phoneNumber"
                    class="is-flex-grow-1 mx-4"></VFieldModel>
                <VFieldModel
                    v-model="content"
                    property="email"
                    class="is-flex-grow-2 mx-4"></VFieldModel>
            </VFlex>
            <!--
        <VFieldModel v-model="content" property="request" class="mx-4 my-2"></VFieldModel>
        -->
            <VFieldModel
                v-model="content"
                property="message"
                class="mx-4 my-2"></VFieldModel>
            <div class="is-flex m-2">
                <img class="image is-48x48 p-1" :src="Megaphone" alt="logo" />
                <p class="is-size-5 has-text-black has-text-weight-bold my-auto ml-2">
                    <Translate>.title.communication</Translate>
                </p>
            </div>
            <div class="mx-4 has-text-dark">
                <VValidation
                    v-slot="{ field }"
                    v-model="content['consent']"
                    property="consent">
                    <VCheckbox v-model="field.value">
                        <span class="has-text-dark">
                            <Translate path=".consent.label-a" />&nbsp;
                            <span>
                                <a :href="RGPD" target="_blank" rel="noreferrer noopener">
                                    <Translate path=".consent.link" />
                                </a> </span
                            >&nbsp;
                            <Translate path=".consent.label-b" />
                        </span>
                    </VCheckbox>
                </VValidation>
            </div>
            <button
                :disabled="!isValid"
                class="button is-normal is-uppercase is-primary mx-auto mt-4 mb-5 has-text-weight-bold is-family-code"
                @click="sendEmail()">
                <Translate path=".submit.label" />
            </button>
        </div>
        <div v-else class="is-flex is-justify-content-center" style="min-height: 400px">
            <section class="my-auto">
                <p
                    class="is-size-5 has-text-centered has-text-dark has-text-weight-bold pb-4">
                    <Translate>.sent.title</Translate>
                </p>
                <p
                    class="is-size-6 has-text-centered has-text-dark"
                    style="line-height: 1.3rem">
                    <Translate>.sent.message</Translate>
                </p>
            </section>
        </div>
    </div>
</template>
